module.exports = __webpack_public_path__ + "img/mood_bad.04a9ff3f.svg";